import React, { type ReactNode, type ReactElement } from "react";

import { type IGranularity, Granularity } from "@north-beam/nb-common";

import { Select } from ".";

type GranularitySelectValue<H extends boolean> = H extends true
  ? IGranularity
  : Exclude<IGranularity, "platform">;

export type GranularitySelectOption<H extends boolean> = {
  label: string;
  value: GranularitySelectValue<H>;
};

interface GranularitySelectProps<H extends boolean> {
  label?: string | ReactElement;
  className?: string;
  isLoading?: boolean;
  granularity: GranularitySelectValue<H>;
  options?: GranularitySelectOption<H>[];
  onChange: (obj: GranularitySelectValue<H>) => void;
  hasPlatform: H;
  icon?: ReactNode;
  maxWidth?: string;
}

export const GranularitySelect = <H extends boolean>({
  label = "GRANULARITY",
  className,
  isLoading = false,
  granularity,
  options,
  onChange,
  hasPlatform,
  ...props
}: GranularitySelectProps<H>) => {
  const selectOptions: GranularitySelectOption<H>[] = (
    options ?? Granularity.reactSelectOptions
  ).filter((opt): opt is GranularitySelectOption<H> => {
    return hasPlatform ? true : opt.value !== "platform";
  });

  return (
    <Select<GranularitySelectValue<H>>
      label={label}
      className={className}
      isLoading={isLoading}
      value={granularity}
      options={selectOptions}
      icon={<i className="fa-regular fa-sharp fa-sitemap" />}
      onChange={onChange}
      {...props}
    />
  );
};
